import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["abbreviate", "abbreviateThreshold", "value", "stripInsignificantZeros"];
import { getLocale } from '../utils/internal/light/intlFormatters';
import { formatIntlCurrency } from '../utils/formatIntlCurrency';
import LegacyFormattedCurrency from './FormattedCurrency';
import { jsx as _jsx } from "react/jsx-runtime";
export function FormattedIntlCurrency(props) {
  try {
    const {
        abbreviate,
        abbreviateThreshold,
        value,
        stripInsignificantZeros = false
      } = props,
      options = _objectWithoutPropertiesLoose(props, _excluded);
    const wrapperAttributes = {};
    const shouldAbbreviate = abbreviate && (typeof abbreviateThreshold !== 'number' || value >= abbreviateThreshold);
    if (shouldAbbreviate) {
      wrapperAttributes.title = formatIntlCurrency(value, Object.assign({}, options, {
        stripInsignificantZeros
      }));
    }
    const formattedCurrency = formatIntlCurrency(value, Object.assign({}, options, {
      stripInsignificantZeros,
      abbreviate: shouldAbbreviate
    }));

    // eslint-disable-next-line react-hooks/error-boundaries
    return /*#__PURE__*/_jsx("span", Object.assign({}, wrapperAttributes, {
      children: formattedCurrency
    }));
  } catch (error) {
    if (error instanceof Error) {
      // eslint-disable-next-line react-hooks/immutability
      error.message = `I18n: FormattedIntlCurrency Error - ${error.message}`;
      console.error(error);
      if (window.Raven) {
        window.Raven.captureException(error, {
          extra: {
            currentLocale: getLocale(props),
            props
          }
        });
      }
    }
    // @ts-ignore currencyCode null vs undefined mismatch
    return /*#__PURE__*/_jsx(LegacyFormattedCurrency, Object.assign({}, props));
  }
}